<script>
    export default {
        props: {
            labelWidth: String,
            label: {
                type: [String, Boolean],
                default: false,
            },
            append: {
                type: Boolean,
                default: false,
            },
        },
        watch: {
            '$slots.label'(v) {
                console.log(v)
            },
            '$slots.append'(v) {
                console.log(v)
            },
        },
        computed: {
            classMain() {
                return {
                    'form-group--label': this.label,
                    'form-group--append': this.append,
                }
            },
        },
        mounted() {
            this.$watch('$slots.default', (v) => {
                console.log(v)
            })
        }
    }
</script>
<template>
    <div class="form-group" :class="classMain">
        <div class="form-group__label" v-if="label" :style="{width: labelWidth}">
            <slot name="labelSelect">
                <span>{{label}}</span>
            </slot>
        </div>
        <div class="form-group__slot">
            <slot></slot>
        </div>
        <div class="form-group__append" v-if="append">
            <slot name="append"></slot>
        </div>
    </div>
</template>
<style lang="scss">
    .form-group {
        display: flex;
        line-height: 1;
        &__slot {
            width: 100%;
            .el-textarea__inner {
                width: 100%;
            }
            .el-select {
                width: 100%;
                .el-input__inner {
                    width: 100%;
                }
            }
            .el-date-editor {
                width: 100%;
                .el-input {
                    .el-input__inner {
                        width: 100%;
                    }
                }
            }
        }
        &__label {
            flex-shrink: 0;
            .el-input__inner {
                border-radius: 4px 0 0 4px;
                background: #fafafa;
                color: #333;
            }
            & > span {
                background: #fafafa;
                border-radius: 4px 0 0 4px;
                padding: 0 8px;
                text-align: right;
                line-height: 26px;
                min-height: 28px;
                display: block;
                border-bottom: 1px solid;
                border-top: 1px solid;
                border-left: 1px solid;
                border-color: #dcdfe6;
                color: #333;
                font-size: 12px;
                height: 100%;
            }
            & > .el-select {
                width: 100%;
            }
        }
        &__append {
            flex-shrink: 0;
            display: flex;
            .form-group__slot-append + .form-group__slot-append {
                border-left: 1px solid #dcdfe6;
            }
            & > span,
            & > .el-button {
                border-radius: 0 0 0 0;
                padding: 0 10px;
                text-align: right;
                line-height: 26px;
                height: 28px;
                display: block;
                border: none;
                border-bottom: 1px solid;
                border-top: 1px solid;
                border-color: #dcdfe6;
                background: #fafafa;
                color: #333;
                flex-shrink: 0;
                margin: 0;
            }
            .el-button + .el-button {
                border-left: 1px solid #dcdfe6;
            }
            span + span {
                border-left: 1px solid #dcdfe6;
            }
            span + .el-button {
                border-left: 1px solid #dcdfe6;
            }
            & > .el-select {
                .el-input__inner {
                    border-radius: 0 0 0 0;
                    background: #fafafa;
                    color: #333;
                }
            }
            & > *:last-child {
                border-radius: 0 4px 4px 0;
                &:not(.el-select) {
                    border-right: 1px solid #dcdfe6;
                }
                .el-input__inner {
                    border-radius: 0 4px 4px 0;
                }
            }
        }
        &--label {
            .form-group__slot {
                .el-textarea__inner {
                    border-radius: 0 4px 4px 0;
                }
                .el-input__inner {
                    border-radius: 0 4px 4px 0;
                }
                .el-radio-button:first-child .el-radio-button__inner {
                    border-radius: 0 0 0 0;
                }
            }
        }
        &--append {
            .form-group__slot {
                .el-textarea__inner {
                    border-radius: 4px 0 0 4px;
                }
                .el-input__inner {
                    border-radius: 4px 0 0 4px;
                }
            }
        }
        .el-select {
            .el-input__inner {
                height: 28px !important;
            }
            .el-select__tags {
                width: 100%;
                & > span {
                    width: 100%;
                }
                .el-select__input {
                    display: none;
                }
                .el-tag {
                    height: 22px;
                    line-height: 20px;
                    &:first-child {
                        width: calc(100% - 55px);
                        .el-select__tags-text {
                            display: inline-block;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            vertical-align: middle;
                            width: calc(100% - 20px);
                            word-break: normal;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }

    .form-group--label.form-group--append {
        .form-group__slot {
            .el-input__inner {
                border-radius: 0 0 0 0;
            }
            .el-textarea__inner {
                border-radius: 0 0 0 0;
            }
        }
    }

    .is-required {
        .form-group__label {
            & > span {
                &:before {
                    content: '*';
                    color: red;
                    margin-right: 4px;
                }
            }
        }
    }

    .is-success {
        .form-group__slot {
            .el-input__inner {
                border: 1px solid #67c23a;
            }
            .el-textarea__inner {
                border: 1px solid #67c23a;
            }
        }
    }
</style>